import { queryOptions, useMutation } from '@tanstack/react-query';

import RequestProfilesRepository from '../repositories/requestProfilesRepository';

import { requestProfileKeys } from './query-keys';

export const requestProfilesQuery = (companyId: string, isCardRequest = false) =>
	queryOptions({
		queryKey: [requestProfileKeys.getRequestProfilesForCompany, companyId],
		queryFn: () => RequestProfilesRepository.getRequestProfilesForCompany({ companyId }),
		enabled: !!companyId && Boolean(isCardRequest),
	});

export const getProfilesQuery = () => ({
	queryKey: [requestProfileKeys.getProfiles],
	queryFn: RequestProfilesRepository.getProfiles,
});

export const useSetProfileForCompany = () => {
	return useMutation<void, unknown, { companyId: string; profileId: string }>({
		mutationFn: RequestProfilesRepository.setProfileForCompany,
	});
};

export const useRemoveProfileForCompany = () => {
	return useMutation<void, unknown, { companyId: string }>({
		mutationFn: RequestProfilesRepository.removeProfileFromCompany,
	});
};
